module.exports = "<p>\r\n  blocco-ruolo-manager works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/blocco-ruolo-manager/blocco-ruolo-manager.component.html
// module id = ../../../../../src/app/components/blocco-ruolo-manager/blocco-ruolo-manager.component.html
// module chunks = main